export default "__VITE_ASSET__4b91af42__"